// extracted by mini-css-extract-plugin
module.exports = {"guide":"Guide_guide__3J7T_","imgFrame":"Guide_imgFrame__2AZ9z","guideBlock":"Guide_guideBlock__3iWLA","highlight":"Guide_highlight__1H8Yz"};